import { render, staticRenderFns } from "./icon-big-check.vue?vue&type=template&id=3f1eaff7&scoped=true&"
var script = {}
import style0 from "./icon-big-check.vue?vue&type=style&index=0&id=3f1eaff7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f1eaff7",
  null
  
)

export default component.exports